import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useSubscriptions} from '../hooks/useSubscriptions';


interface DeleteRecordButtonProps {
    selectedIds: string[];
    onDeleteComplete?: () => void;
}

export const DeleteRecordButton = ({selectedIds, onDeleteComplete}: DeleteRecordButtonProps) => {

    const {deleteRecords} = useSubscriptions();

    const disabled = selectedIds.length === 0;

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={selectedIds.length}
        handleConfirm={() => {
            deleteRecords(selectedIds);
            onDeleteComplete?.();
        }}/>);
};
